import React, { useEffect, useRef, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { LOGIN } from "../constants/routes";
import { logoutRequest } from "../modules/login/services/LoginActions";
import { getCookie } from "../store/localStorage";

const PrivateRoute = ({ children, allowedRoles }) => {
    const dispatch = useDispatch();
    const location = useLocation();

    const { userData } = useSelector(state => state.auth);
    const { selectedRole } = useSelector(state => state.common);

    const roleMismatchRef = useRef(false);
    const [cookieMissing, setCookieMissing] = useState(false);

    const isLoggedIn = !!userData?.userId;
    const activeRole = selectedRole?.code;

    const hasRoleAccess =
        !allowedRoles || (activeRole && allowedRoles.includes(activeRole));

    // Check selectedRole cookie on every refresh
    useEffect(() => {
        const roleFromCookie = getCookie("selectedRole");

        if (isLoggedIn && !roleFromCookie) {
            setCookieMissing(true);
            dispatch(logoutRequest({ reason: "session_expired" }));
        }
    }, [isLoggedIn, dispatch]);

    // Detect role mismatch ONCE
    useEffect(() => {
        if (isLoggedIn && selectedRole && !hasRoleAccess) {
            roleMismatchRef.current = true;
            dispatch(logoutRequest({ reason: "role_mismatch" }));
        }
    }, [isLoggedIn, selectedRole, hasRoleAccess, dispatch]);

    // Not logged in normally
    if (!isLoggedIn) {
        return (
            <Navigate
                to={{ pathname: LOGIN, search: location.search, hash: location.hash }}
                replace
                state={{ from: location }}
            />
        );
    }

    // Redirect due to missing cookie (after refresh)
    if (cookieMissing) {
        return (
            <Navigate
                to={LOGIN}
                replace
            />
        );
    }

    // Redirect due to ROLE mismatch
    if (roleMismatchRef.current) {
        return (
            <Navigate
                to={LOGIN}
                replace
            />
        );
    }
    return children;
};

export default PrivateRoute;
